import { Component, OnInit } from '@angular/core';
import { DialogConfig, DialogService } from '@tmhcc-ng-lib/framwork/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppDataService } from '@tmhcc-ng-lib/data-service';
import { FormValidatorService } from '@tmhcc-ng-lib/content-service';

@Component({
  selector: 'ae-sign-application',
  templateUrl: './sign-application.component.html',
  styleUrls: ['./sign-application.component.scss']
})
export class SignApplicationComponent implements OnInit {
  signApp: FormGroup;
  submitted = false;
  formFields: any = {};
  signAppBtn;
  constructor(
    public dialogData: DialogConfig,
    public dialogService: DialogService,
    private fb: FormBuilder,
    private formValidatorService: FormValidatorService,
    private appDataService: AppDataService
  ) {}

  ngOnInit(): void {
    this.signApp = this.fb.group({
      insuredEmail: [''],
      producerEmail: ['']
    });

    this.appDataService.getStepsSitecoreData().subscribe(res => {
      if (res) {
        this.signAppBtn = res.buttons;
        this.formFields.insuredEmailField = this.fetchFormFields(
          res.forms[4].fields,
          'Insured Email Address'
        );
        this.formFields.producerEmailField = this.fetchFormFields(
          res.forms[4].fields,
          'Producer Email Address'
        );

        const insuredEmailValidations = this.formValidatorService.setFormValidator(
          this.formFields.insuredEmailField
        );

        this.f.insuredEmail.setValidators(insuredEmailValidations);
        this.f.insuredEmail['requiredError'] = this.fetchValidationValue(
          this.formFields.insuredEmailField.fieldInfo.validations,
          'Required'
        ).value;
      }
    });
  }

  fetchValidationValue(validations: any[], key: string) {
    const filterObj = validations.filter(ele => ele.key == key);
    if (filterObj.length) return filterObj[0];
    return filterObj;
  }
  fetchFormFields(fields: any[], label: string) {
    const filterObj = fields.filter(ele => ele.fieldInfo.label == label);
    if (filterObj.length) return filterObj[0];
    return filterObj;
  }

  get f() {
    return this.signApp.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.signApp.invalid) {
      return;
    } else {
    }
  }
}
